"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginWithSigner = exports.loginWithMetamask = exports.signerErrors = exports.SignerAPI = void 0;
var signer_1 = require("@waves/signer");
var provider_web_1 = require("@waves.exchange/provider-web");
var provider_ledger_1 = require("@waves/provider-ledger");
var provider_cloud_1 = require("@waves.exchange/provider-cloud");
var provider_metamask_1 = require("@waves/provider-metamask");
var signer_2 = require("@waves/signer");
Object.defineProperty(exports, "SignerAPI", { enumerable: true, get: function () { return signer_2.Signer; } });
exports.signerErrors = {
    rejectedByUser: 'rejectedByUser',
    wrongNetwork: 'wrongNetwork',
    authExpired: 'authExpired',
};
var loginWithMetamask = function (params) {
    var _a = params !== null && params !== void 0 ? params : {
        nodeUrl: 'https://nodes-stagenet.wavesnodes.com',
        chainId: 'S'
    }, nodeUrl = _a.nodeUrl, chainId = _a.chainId;
    var signer = new signer_1.Signer({
        NODE_URL: nodeUrl,
    });
    var provider = new provider_metamask_1.ProviderMetamask({
        wavesConfig: {
            nodeUrl: nodeUrl,
            chainId: chainId.charCodeAt(0)
        }
    });
    signer.setProvider(provider);
    return signer.login()
        .then(function (x) {
        // console.log("RESULT")
        // console.log({ address: x.address, publicKey: x.publicKey, signer })
        return ({ address: x.address, signer: signer });
    })
        .catch(function (x) {
        var _a;
        console.log("ERROR");
        if (((_a = x === null || x === void 0 ? void 0 : x.message) === null || _a === void 0 ? void 0 : _a.includes('rejection')) || (x === null || x === void 0 ? void 0 : x.includes('rejection')))
            return Promise.reject(exports.signerErrors.rejectedByUser);
        return Promise.reject(x);
    });
};
exports.loginWithMetamask = loginWithMetamask;
var loginWithSigner = function (type) {
    var signer = new signer_1.Signer();
    if (type === 'email') {
        signer.setProvider(new provider_cloud_1.ProviderCloud());
    }
    else if (type === 'ledger') {
        signer.setProvider(new provider_ledger_1.ProviderLedger());
    }
    else {
        signer.setProvider(new provider_web_1.ProviderWeb());
    }
    return signer.login()
        .then(function (x) { return ({ address: x.address, publicKey: x.publicKey, signer: signer }); })
        .catch(function (x) {
        var _a;
        if (((_a = x === null || x === void 0 ? void 0 : x.message) === null || _a === void 0 ? void 0 : _a.includes('rejection')) || (x === null || x === void 0 ? void 0 : x.includes('rejection')))
            return Promise.reject(exports.signerErrors.rejectedByUser);
        return Promise.reject(x);
    });
};
exports.loginWithSigner = loginWithSigner;
//# sourceMappingURL=signer.js.map